export function urlify(text) {
  if (!text) return null;
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function(url) {
    return '<a href="' + url + '"  target="_blank">' + url + '</a>';
  });
}
